var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFaq = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 26,
    fill: "none",
    viewBox: "0 0 32 26",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.401.854c-.165-.01-.33-.01-.495-.01-8.545 0-15.5 5.605-15.5 12.5.02 2.505.915 4.925 2.53 6.84l-1.02 5.06a.5.5 0 0 0 .15.465.49.49 0 0 0 .48.115l5.68-1.63a18.4 18.4 0 0 0 7.68 1.65c7.075 0 13.24-3.845 15.005-9.355.328-1.017.495-2.078.495-3.145 0-6.8-6.595-12.29-15.005-12.49m3.17 9.375a2.8 2.8 0 0 1-.4 1.51 5.6 5.6 0 0 1-1.51 1.43c-.36.24-.685.529-.965.86-.144.23-.214.499-.2.77v.475h-2.11v-.585a2.6 2.6 0 0 1 .33-1.33 4.3 4.3 0 0 1 1.19-1.2 4.9 4.9 0 0 0 1.1-.97c.177-.242.27-.536.265-.835a.9.9 0 0 0-.38-.785 1.82 1.82 0 0 0-1.065-.27 6.1 6.1 0 0 0-2.715.78l-.87-1.74a7.56 7.56 0 0 1 3.76-.995 4 4 0 0 1 2.605.785 2.58 2.58 0 0 1 .965 2.1m-5.07 8.76a1.3 1.3 0 0 1-.365-.995 1.33 1.33 0 0 1 .355-1.01 1.44 1.44 0 0 1 1.04-.34c.375-.024.743.102 1.025.35a1.32 1.32 0 0 1 .36 1 1.35 1.35 0 0 1-.365.99 1.4 1.4 0 0 1-1.02.36 1.42 1.42 0 0 1-1.03-.355"
  })));
};
export default SvgFaq;